module.exports = "\n<footer class=\"footer\">\n  <div class=\"container-fluid\">\n    <div class=\"copyright\">\n      <div class=\"footer\" align=\"center\">\n        Copyright <a href=\"www.smart-study.at\">\n          Smart-Study</a>, \n          All rights reserved.\n           <a href=\"www.smart-study.at\">www.smart-study.at</a> </div>\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main